import { App } from "./kernel/kernel";
import Router from "./kernel/core/router";
import Backbone from "backbone";
import IdentityAndAccessController from "controllers/identity-and-access-controller";
import raf from "raf";
import "scss/init.scss"

/**
 * Monkey patch backbone sync method
 */
const oldSync = Backbone.sync;
Backbone.sync = function(method, model, options) {
    if (IdentityAndAccessController.sessionStatus) {
        /*
         * The jQuery "ajax" method includes a "headers" option
         * which lets you set any headers you like
         */
        options.headers = {
            /*
             * Set the "Authorization" header and get the access
             * token from the `auth` module
             */
            "Authorization": `bearer ${IdentityAndAccessController.sessionKey}`
        };
    }

    raf(_ => {
        const xhr = options.xhr;

        /**
         * When the model returns a failed request, check if it's a 401.
         *
         * @type {jqXHR} jQuery XHR object
         */
        xhr.fail(e => {
            if(parseInt(e.status) === 401) {
                IdentityAndAccessController.destroySession();
                Backbone.history.navigate("/?sessionEnded=1", {
                    trigger: true,
                    replace: true
                });
            }
        })
    });

    /*
     * Call the stored original Backbone.sync method with
     * extra headers argument added
     */
    return oldSync(method, model, options);
};

/**
 * Monkey patch the router
 */
const loadUrl = Backbone.History.prototype.loadUrl;

Backbone.History.prototype.loadUrl = function() {
    if (!loadUrl.apply(this, arguments)) {
        if (IdentityAndAccessController.sessionStatus) {
            System.import("domain/views/404").then(View => {
                const view = new View.default();
                raf(_ => App.contentRegion.show(view));
            });
        } else {
            raf(_ => {
                Backbone.history.navigate("/", {
                    trigger: true,
                    replace: true
                });
            });
        }
    }
};

App.start();



// WEBPACK FOOTER //
// ./public/main.js